import axios from "axios";
import mockPayload from "../mocks/malla-curricular-mgilp.json";
import { POSGRADO_MALLA_MATERIAS } from "../data/posgradoCourseDetail.materias";
import { normalizePosgradoResponse } from "../utils/normalizePosgradoResponse";

const USE_MALLA_MOCK = process.env.REACT_APP_USE_MALLA_MOCK === "true";

function buildMockPosgrado(id) {
  const attributes = {
    ...mockPayload.data.attributes,
    MallaCurricular: {
      ...mockPayload.data.attributes.MallaCurricular,
      Materias: POSGRADO_MALLA_MATERIAS,
    },
  };
  return normalizePosgradoResponse({
    data: {
      id: Number(id) || mockPayload.data.id,
      attributes,
    },
  });
}

function shouldFallbackToMock(attributes) {
  const materias = attributes?.MallaCurricular?.Materias;
  return !materias || materias.length === 0;
}

export async function fetchPosgradoById(id) {
  if (USE_MALLA_MOCK) {
    return buildMockPosgrado(id);
  }

  const baseUrl = process.env.REACT_APP_API_URL;
  if (!baseUrl) {
    console.warn("[posgradoApi] REACT_APP_API_URL missing; using mock.");
    return buildMockPosgrado(id);
  }

  const query =
    "populate[MallaCurricular][populate]=Materias&populate[imagen]=*";
  const url = `${baseUrl}/api/posgrados/${id}?${query}`;

  try {
    const response = await axios.get(url);
    const normalized = normalizePosgradoResponse(response.data);

    if (shouldFallbackToMock(normalized.attributes)) {
      console.warn(
        "[posgradoApi] Empty malla from API; falling back to mock materias."
      );
      const mock = buildMockPosgrado(id);
      if (normalized.attributes) {
        mock.attributes = {
          ...normalized.attributes,
          MallaCurricular: mock.attributes.MallaCurricular,
        };
      }
      return mock;
    }

    return normalized;
  } catch (error) {
    console.warn("[posgradoApi] Request failed; using mock.", error.message);
    return buildMockPosgrado(id);
  }
}
